export const NAME = 'formDialog';
export const LINK_FORM_NAME = 'linkForm';
export const IMAGE_BLOCK_FORM_NAME = 'imageBlockForm';
